var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonochrome3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7513 4.51025H18.7513C17.6014 4.50961 16.6686 5.44127 16.668 6.59121C16.668 6.592 16.668 6.5928 16.668 6.59359V14.9269H33.3346C34.4846 14.9263 35.4173 15.8579 35.418 17.0079C35.418 17.0087 35.418 17.0095 35.418 17.0103V33.6769H43.7513C44.9012 33.6776 45.834 32.7459 45.8346 31.596C45.8346 31.5952 45.8346 31.5944 45.8346 31.5936V6.59359C45.8353 5.44365 44.9036 4.5109 43.7537 4.51025C43.7529 4.51025 43.7521 4.51025 43.7513 4.51025Z",
    fill: "#C1C0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2513 25.3438H22.918C24.0686 25.3438 25.0013 26.2765 25.0013 27.4271V44.0938C25.0013 45.2443 24.0686 46.1771 22.918 46.1771H6.2513C5.10072 46.1771 4.16797 45.2443 4.16797 44.0938V27.4271C4.16797 26.2765 5.10072 25.3438 6.2513 25.3438Z",
    fill: "#6563FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3346 14.9272H12.5013C11.3514 14.9266 10.4186 15.8583 10.418 17.0082C10.418 17.009 10.418 17.0098 10.418 17.0106V25.3439H22.918C24.0679 25.3433 25.0007 26.2749 25.0013 27.4249C25.0013 27.4257 25.0013 27.4265 25.0013 27.4272V39.9272H33.3346C34.4846 39.9279 35.4173 38.9962 35.418 37.8463C35.418 37.8455 35.418 37.8447 35.418 37.8439V17.0106C35.4186 15.8606 34.4869 14.9279 33.337 14.9272C33.3362 14.9272 33.3354 14.9272 33.3346 14.9272Z",
    fill: "#A2A1FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonochrome3);
export default __webpack_public_path__ + "static/media/Monochrome 3.f36cd1aa2c7284ccc3d80fa22eaad50b.svg";
export { ForwardRef as ReactComponent };